module.exports = "/shifts/introduction-17eec9.html";